<template>
  <div>
    <p class="title" style="margin-bottom: 40px; font-weight: 500">Chi tiết file upload</p>
    
    <el-card shadow="never" class="mt3" v-loading="loading">
      <table class="detail-table">
        <tr>
          <td class="label">ID</td>
          <td class="value">{{ fileDetail.id }}</td>
        </tr>
        <tr>
          <td class="label">Tên file</td>
          <td class="value">{{ fileDetail.original_file_name }}</td>
        </tr>
        <tr>
          <td class="label">Chữ ký số</td>
          <td class="value">
            <span class="signature-box">{{ fileDetail.signature }}</span>
          </td>
        </tr>
        <tr>
          <td class="label">Người upload</td>
          <td class="value">{{ fileDetail.uploader_name }}</td>
        </tr>
        <tr>
          <td class="label">Thời gian upload</td>
          <td class="value">{{ fileDetail.uploaded_at | formatDatetime }}</td>
        </tr>
        <tr>
          <td class="label">Người ký</td>
          <td class="value">
            <span class="signer-box">{{ getSignerName(fileDetail.signature) }}</span>
          </td>
        </tr>
      </table>

      <div class="action-buttons mt3">
        <el-button 
          type="primary" 
          @click="handleDownload"
          :loading="downloading"
        >
          <i class="el-icon-download"></i> Tải xuống file
        </el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import CooperatorRequest from "../api/cooperator";

export default {
  name: "FileUploadDetail",
  data() {
    return {
      loading: false,
      downloading: false,
      fileDetail: {
        id: null,
        original_file_name: '',
        signature: '',
        uploader_name: '',
        uploaded_at: '',
      }
    };
  },
  methods: {
    async fetchFileDetail() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        const res = await CooperatorRequest.getFileDetail(id);
        if (res.success) {
          this.fileDetail = res.data;
        }
      } catch (error) {
        console.error('Error fetching file detail:', error);
        this.$message.error('Có lỗi xảy ra khi tải thông tin file');
      }
      this.loading = false;
    },

    async handleDownload() {
      this.downloading = true;
      try {
        const res = await CooperatorRequest.downloadFile(this.fileDetail.id);
        this.downloadFile(res, this.fileDetail.original_file_name.replace('.pdf', ''), 'pdf');
      } catch (error) {
        console.error('Error downloading file:', error);
        this.$message.error('Có lỗi xảy ra khi tải xuống file');
      }
      this.downloading = false;
    },

    getSignerName(signature) {
      if (!signature) return '';
      const match = signature.match(/CN=([^,]+)/);
      return match ? match[1].trim() : '';
    }
  },
  created() {
    this.fetchFileDetail();
  }
};
</script>

<style lang="scss" scoped>
.detail-table {
  width: 100%;
  border-collapse: collapse;
  
  tr {
    &:nth-child(odd) {
      background-color: #fafafa;
    }
    
    &:nth-child(even) {
      background-color: #ffffff;
    }
  }

  td {
    padding: 12px 16px;
    border: 1px solid #ebeef5;
    
    &.label {
      width: 200px;
      font-weight: 500;
      color: #606266;
      background-color: #f5f7fa;
    }
    
    &.value {
      color: #303133;
    }
  }
}

.action-buttons {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.signature-box {
  background: #e6f7ff;
  color: #1890ff;
  border-radius: 4px;
  padding: 4px 8px;
  display: inline-block;
  font-size: 13px;
  word-break: break-word;
}

.signer-box {
  display: inline-block;
  background: #e6ffed;
  color: #389e0d;
  border: 1px solid #b7eb8f;
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 500;
}

/deep/ .el-card__body {
  padding: 20px;
}
</style> 